import { starterDeck } from "../builder";

export const EN_RU_BUSINESS = starterDeck({
  id: "en-ru-business-b1",
  name: "Бизнес и встречи",
  name_en: "Business & Meetings",
  description: "Лексика для совещаний, переговоров и переписки.",
  description_en: "Vocabulary for meetings, negotiations, and correspondence.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "business",
  ageGroup: "professional",
  level: "B1",
  cards: [
    ["meeting", "встреча, совещание"],
    ["agenda", "повестка"],
    ["minutes", "протокол встречи"],
    ["deadline", "крайний срок"],
    ["schedule", "расписание"],
    ["proposal", "предложение"],
    ["contract", "контракт"],
    ["client", "клиент"],
    ["customer", "заказчик / покупатель"],
    ["partner", "партнёр"],
    ["stakeholder", "заинтересованное лицо"],
    ["revenue", "выручка"],
    ["profit", "прибыль"],
    ["loss", "убыток"],
    ["budget", "бюджет"],
    ["invoice", "счёт-фактура"],
    ["forecast", "прогноз"],
    ["KPI", "ключевой показатель эффективности"],
    ["to follow up", "уточнить позже, продолжить контакт", "phrase"],
    ["to reach out", "связаться", "phrase"],
    ["to align on", "согласовать (позицию)", "phrase"],
    ["let's circle back", "вернёмся к этому позже", "idiom"],
    ["bandwidth", "ресурсы / возможности (сленг)", "idiom"],
  ],
});

export const EN_RU_FINANCE = starterDeck({
  id: "en-ru-finance-b2",
  name: "Финансы",
  name_en: "Finance",
  description: "Термины инвестиций, отчётности и рынков.",
  description_en: "Terms for investing, reporting, and markets.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "finance",
  ageGroup: "professional",
  level: "B2",
  cards: [
    ["asset", "актив"],
    ["liability", "обязательство"],
    ["equity", "капитал / доля"],
    ["balance sheet", "балансовый отчёт", "phrase"],
    ["cash flow", "денежный поток", "phrase"],
    ["interest rate", "процентная ставка", "phrase"],
    ["inflation", "инфляция"],
    ["depreciation", "амортизация"],
    ["dividend", "дивиденд"],
    ["stock", "акция"],
    ["bond", "облигация"],
    ["portfolio", "портфель (инвестиций)"],
    ["yield", "доходность"],
    ["leverage", "плечо / заёмные средства"],
    ["volatility", "волатильность"],
    ["hedge", "хеджирование"],
    ["margin call", "маржин-колл", "phrase"],
    ["fiscal year", "финансовый год", "phrase"],
    ["overhead", "накладные расходы"],
    ["audit", "аудит"],
  ],
});

export const EN_RU_IT = starterDeck({
  id: "en-ru-it-b2",
  name: "IT и разработка",
  name_en: "IT & Development",
  description: "Базовая инженерная и продуктовая лексика.",
  description_en: "Basic engineering and product vocabulary.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "it",
  ageGroup: "professional",
  level: "B2",
  cards: [
    ["bug", "баг, ошибка"],
    ["feature", "функция, фича"],
    ["release", "релиз, выпуск"],
    ["deploy", "развёртывание / деплой"],
    ["build", "сборка"],
    ["repository", "репозиторий"],
    ["branch", "ветка"],
    ["merge", "слияние"],
    ["commit", "коммит"],
    ["pull request", "пулл-реквест", "phrase"],
    ["code review", "ревью кода", "phrase"],
    ["refactor", "рефакторинг"],
    ["dependency", "зависимость"],
    ["framework", "фреймворк"],
    ["library", "библиотека"],
    ["API", "программный интерфейс"],
    ["endpoint", "эндпоинт"],
    ["latency", "задержка, латентность"],
    ["throughput", "пропускная способность"],
    ["cache", "кэш"],
    ["database", "база данных"],
    ["query", "запрос"],
    ["scalable", "масштабируемый"],
    ["legacy code", "устаревший код", "phrase"],
  ],
});

export const EN_RU_AI = starterDeck({
  id: "en-ru-ai-c1",
  name: "ИИ и машинное обучение",
  name_en: "AI & Machine Learning",
  description: "Термины машинного обучения и нейросетей.",
  description_en: "Machine learning and neural network terminology.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "ai",
  ageGroup: "professional",
  level: "C1",
  cards: [
    ["model", "модель"],
    ["training", "обучение (модели)"],
    ["inference", "инференс, вывод"],
    ["dataset", "датасет, набор данных"],
    ["label", "метка"],
    ["feature", "признак"],
    ["embedding", "эмбеддинг, векторное представление"],
    ["fine-tuning", "дообучение, тонкая настройка"],
    ["prompt", "промпт, запрос"],
    ["token", "токен"],
    ["context window", "контекстное окно", "phrase"],
    ["hallucination", "галлюцинация (ошибка модели)"],
    ["overfitting", "переобучение"],
    ["regularization", "регуляризация"],
    ["gradient descent", "градиентный спуск", "phrase"],
    ["transformer", "трансформер (архитектура)"],
    ["attention", "механизм внимания"],
    ["reinforcement learning", "обучение с подкреплением", "phrase"],
    ["agent", "агент"],
    ["latent space", "латентное пространство", "phrase"],
  ],
});

export const EN_RU_MEDICINE = starterDeck({
  id: "en-ru-medicine-b2",
  name: "Медицина — базовый словарь",
  name_en: "Medicine — Basic Vocabulary",
  description: "Базовые термины на приёме у врача.",
  description_en: "Basic terms for a doctor's appointment.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "medicine",
  ageGroup: "professional",
  level: "B2",
  cards: [
    ["patient", "пациент"],
    ["doctor", "врач"],
    ["nurse", "медсестра"],
    ["surgeon", "хирург"],
    ["diagnosis", "диагноз"],
    ["symptom", "симптом"],
    ["treatment", "лечение"],
    ["prescription", "рецепт"],
    ["dose", "доза"],
    ["fever", "температура / жар"],
    ["cough", "кашель"],
    ["pain", "боль"],
    ["allergy", "аллергия"],
    ["infection", "инфекция"],
    ["wound", "рана"],
    ["surgery", "операция"],
    ["X-ray", "рентген"],
    ["blood pressure", "артериальное давление", "phrase"],
    ["heart rate", "частота сердечных сокращений", "phrase"],
    ["chronic", "хронический"],
  ],
});
